import type { SubmittedDocument } from "../types/SubmittedDocument";
import { DocumentState } from "../types/enums/DocumentState";

export const canReopenStudentDocument = (document: SubmittedDocument) =>
  document.state === DocumentState.submitted &&
  document.startGradingAtTimestamp == null &&
  document.finishedGradingAtTimestamp == null;
